import React from "react";
import Maze from "../../Maze";

const Screen19 = () => {
    return <Maze />;
};

export default Screen19;
